<app-page-cardhead [PageName]="'Branch: '+userService.userBranchName" [PageHeadWidth]="650"></app-page-cardhead>

<app-lmsclient-search [branchSerial]="userService.userBranchSerial"
      [preAuthorisationModel]="preAuthorisationModel" [OverrideDefaultSearch]="true" resetLoan="true"
      (onViewSearchedClient)="searchedClientView($event)"></app-lmsclient-search>
